import { render } from "./WdProfile.vue?vue&type=template&id=47c30ec3&scoped=true"
import script from "./WdProfile.vue?vue&type=script&lang=js"
export * from "./WdProfile.vue?vue&type=script&lang=js"

import "./WdProfile.vue?vue&type=style&index=0&id=47c30ec3&lang=scss&scoped=true"

import exportComponent from "D:\\工作项目-new1014\\专题页\\joining_trader_web\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c30ec3"]])

export default __exports__